import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useNavigation, useRoute, RouteProp } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import type { MessagesStackParamList } from '@/navigation/residents/mobile/MessagesStackNavigator';
import { CHAT_MOBILE_COLORS } from '@/constants/residents/mobile/chatColors';
import ResidentCreateConversation from '@/components/residents/propertyChat/ResidentCreateConversation';

type Nav = StackNavigationProp<MessagesStackParamList, 'NewConversation'>;
type Route = RouteProp<MessagesStackParamList, 'NewConversation'>;

/**
 * New Conversation Screen
 * Modal screen for creating a new property chat conversation
 */
export const NewConversationScreen: React.FC = () => {
  const navigation = useNavigation<Nav>();
  const route = useRoute<Route>();
  const initialSubject = route.params?.initialSubject;

  const handleClose = () => {
    navigation.goBack();
  };

  const handleCreated = (conversationId: number, subject?: string) => {
    navigation.replace('Conversation', { conversationId, subject });
  };

  return (
    <View style={styles.container}>
      <ResidentCreateConversation
        onClose={handleClose}
        onCreated={handleCreated}
        initialSubject={initialSubject}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: CHAT_MOBILE_COLORS.cardBackground,
  },
});

export default NewConversationScreen;
